import script from "./SideBarPrimaryDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarPrimaryDropdown.vue?vue&type=script&setup=true&lang=js"

import "./SideBarPrimaryDropdown.vue?vue&type=style&index=0&id=34b2362e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34b2362e"]])

export default __exports__